export const isStatusCode403 = (status: number) => status === 403
